import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getProfile, ProfileResponse, updateProfile, UpdateProfileRequest } from '@/api/profile';
import { useAuth } from '@/contexts/AuthContext';

export const useProfile = () => {
  const { isAuthenticated } = useAuth();

  return useQuery<ProfileResponse, Error>({
    queryKey: ['profile'],
    queryFn: getProfile,
    staleTime: 1000 * 60 * 5, // 5分間はキャッシュを使用
    refetchOnWindowFocus: true, // ウィンドウフォーカス時に再取得
    enabled: isAuthenticated, // 認証済みの場合のみ実行
  });
};

export const useUpdateProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateProfileRequest) => updateProfile(data),
    onSuccess: () => {
      // プロフィール情報を再取得
      queryClient.invalidateQueries({ queryKey: ['profile'] });
    },
  });
};
